import { createAsyncThunk } from '@reduxjs/toolkit';
import { setSelectedProjectBankFolder } from 'store/filepermissions/actions/filepermissions.actions';
import { loadProjectBankFolderContents } from './loadProjectBankFolderContents.thunk';
import { loadProjectBankFormsFolderContents } from './loadProjectBankFormsFolderContents.thunk';
import { selectProjectFolderFilePermissionsArray } from '../selectors/project-bank.selectors';
import {
  getProjectIdFromProjectBankFormsFolderId,
  isProjectBankFormsFolderId,
} from 'scenes/ProjectBank/utils/projectBankForms';

export const selectProjectBankFolder = createAsyncThunk(
  'projectBank/selectProjectBankFolder',
  async (params, { dispatch, getState }) => {

    let folderId = params.folderId;

    const skipSetSelected = params.skipSetSelected || false;

    if (!folderId) {
      const projectFolders = selectProjectFolderFilePermissionsArray(getState());

      const initialFolder = projectFolders.find(
        (folder) => folder.path === params.path
      );

      if (initialFolder) {
        folderId = initialFolder.id;
      }
    }

    // Add folderId to params if it was missing
    const tempParams = { ...params, folderId };

    // If skipSetSelected is true, do not dispatch setSelectedProjectBankFolder
    if (!skipSetSelected) {
      dispatch(setSelectedProjectBankFolder(tempParams));
    }

    if (isProjectBankFormsFolderId(folderId)) {
      const projectId = getProjectIdFromProjectBankFormsFolderId(folderId);
      const isAlreadyLoaded =
        getState().projectBank.loadedProjectBankFormsByProjectId[projectId] ===
        true;

      if (!isAlreadyLoaded && projectId) {
        await dispatch(loadProjectBankFormsFolderContents(projectId));
      }

      return;
    }

    await dispatch(loadProjectBankFolderContents(folderId));
  }
);
